// Datum-Hilfsfunktionen — timezone-sicher für alle Zeitzonen

// "YYYY-MM-DD" → Date (lokale Mitternacht, nie UTC)
// new Date("YYYY-MM-DD") parst als UTC → in UTC+ Zeitzonen falscher Tag
export const parseDateString = (dateStr: string): Date => {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d);
};

// Date → "YYYY-MM-DD" (lokales Datum, nie toISOString)
// toISOString() gibt UTC zurück → in UTC+ Zeitzonen einen Tag zu früh
export const toLocalDateString = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const getWeekStart = (date: Date): Date => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
  d.setDate(diff);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const addDays = (date: Date, days: number): Date => {
  const newDate = new Date(date);
  newDate.setDate(date.getDate() + days);
  return newDate;
};